// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

import { getAPI } from '@/api'

export const parseHostTags = tags => [...new Set((tags || '').split(',').map(tag => tag.trim()).filter(Boolean))]
export const containsHostTags = (available, required) => parseHostTags(required).every(tag => parseHostTags(available).includes(tag))
export const templateMatchesOffering = (template, offering) => !!offering && (!parseHostTags(template.templatetag).length || containsHostTags(template.templatetag, offering.hosttags))

// Filter before pagination so compatible entries on later API pages remain visible.
export async function listAllEntries (command, params, responseKey, itemKey) {
  const items = []
  const pageSize = 500
  for (let page = 1; ; page++) {
    const json = await getAPI(command, { ...params, page, pageSize })
    const response = json[responseKey] || {}
    const batch = response[itemKey] || []
    items.push(...batch)
    if (!batch.length || items.length >= (response.count ?? items.length)) return items
  }
}
